import React, { useCallback, useState } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import ReportModal from '../../../components/report-button/report-modal';
import VerticalDots from 'mdi-react/DotsVerticalIcon';
import Dropdown from '@prisjakt/ui-dropdown-new';
import * as RegularStyle from '../../styles-old';
import * as S from './styles';
import { IAlternativePriceRowCommonProps } from './types';

const OptionsColumn: React.FC<IAlternativePriceRowCommonProps> = props => {
  const { price, store, productImage } = props;
  const { t } = useAppContext();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  return (
    <RegularStyle.Column>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        priceId={price.id}
        priceValue={price.price && price.price.exclShipping}
        store={store}
        productImage={productImage}
        productName={price.name}
        stockStatus={price.stock && price.stock.status}
      />

      <S.Options>
        <Dropdown
          variant="secondary"
          showArrow={false}
          toggleElement={
            <S.OptionsButton>
              <VerticalDots />
            </S.OptionsButton>
          }
          grow="right"
        >
          <S.ReportOverlay>
            <S.Option type="button" onClick={openModal}>
              {t('feedback', 'dialog.prompt-button')}
            </S.Option>
          </S.ReportOverlay>
        </Dropdown>
      </S.Options>
    </RegularStyle.Column>
  );
};

export default OptionsColumn;
